/**
 * 
 * This file was moved and simplified from the theme editor header in 4/8/26
 * Moved the theme editor footer script for coloring the special offers navigation in 4/8/26
 *  
 * */ 

document.addEventListener('DOMContentLoaded', () => {
  // Colors for each letter in the BYOS logo
  const COLOR_MAP = {
    B: '#E8807E',
    Y: '#D9AC38',
    O: '#46D6AD',
    S: '#D4DC33'
  };

  // Replaces the text "BYOS" in a nav element with individually colored letters
  // wrapped in a flex container to control letter spacing
  function colorizeByos(el) {
    if (el.textContent.trim() !== 'BYOS') return;

    const letters = [...'BYOS']
      .map(char => `<span style="color:${COLOR_MAP[char]}">${char}</span>`)
      .join('');

    // Flex wrapper allows fine-grained spacing control between letters
    el.innerHTML = `<div style="display:flex">${letters}</div>`;
  }

  // Apply colored BYOS logo to both mobile nav and desktop header nav links
  document.querySelectorAll('.mobile-nav__link, .header__linklist-link')
    .forEach(colorizeByos);

  // Highlight "Special Offers" in red in the mobile nav
  document.querySelectorAll('.mobile-nav__link.heading.h6').forEach(link => {
    if (link.textContent.trim() === 'Special Offers') {
      link.style.color = 'red';
    }
  });

  document
    .querySelectorAll('.linklist__item a, .mobile-nav__item a, .header__linklist-link, button.mobile-nav__link')
    .forEach(function (el) {
      if (
        el.textContent.trim().toUpperCase().includes('END OF SHIFT SALE') ||
        el.textContent.trim().toUpperCase().includes('SPECIAL OFFERS')
      ) {
        el.style.color = 'red';
      }
    });
});